module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-15.7eeaecf5.png";